<template>
  <div>
    <mu-row gutter v-if="iconMode">
      <mu-col :desktop="type === 'datetime' ? '50' : '100'" :tablet="type === 'datetime' ? '50' : '100'" width="100">
        <mu-date-picker
          v-model="date"
          iconClass="blueIcon"
          icon="date_range"
          :hintText="$t('message.labelDate')"
          inputClass="datePickerDateEl"
          format="DD-MM-YYYY"
          :dateTimeFormat="dateFormat"
          fullWidth
          :okLabel="$t('message.okText')"
          :cancelLabel="$t('message.cancelText')"
          @change="dateChanged"
        ></mu-date-picker>
      </mu-col>
      <mu-col v-if="type !== 'date'" desktop="50" :tablet="type === 'datetime' ? '50' : '100'" width="100" >
        <mu-time-picker
          v-model="time"
          iconClass="blueIcon"
          icon="access_time"
          :hintText="$t('message.labelTime')"
          inputClass="datePickerTimeEl"
          mode="portrait"
          :okLabel="$t('message.okText')"
          :cancelLabel="$t('message.cancelText')"
          fullWidth
          @change="timeChanged"
        ></mu-time-picker>
      </mu-col>
    </mu-row>
    <mu-row v-else>
      <mu-col :desktop="type === 'datetime' ? '50' : '100'" :tablet="type === 'datetime' ? '50' : '100'" width="100">
        <mu-date-picker
          v-model="date"
          iconClass="blueIcon"
          :hintText="$t('message.labelDate')"
          inputClass="datePickerDateEl"
          format="DD-MM-YYYY"
          :dateTimeFormat="dateFormat"
          fullWidth
          :okLabel="$t('message.okText')"
          :cancelLabel="$t('message.cancelText')"
          @change="dateChanged"
        ></mu-date-picker>
      </mu-col>
      <mu-col desktop="50" tablet="50" width="100">
        <mu-time-picker
          v-if="type !== 'date'"
          v-model="time"
          iconClass="blueIcon"
          :hintText="$t('message.labelTime')"
          inputClass="datePickerTimeEl"
          mode="portrait"
          :okLabel="$t('message.okText')"
          :cancelLabel="$t('message.cancelText')"
          fullWidth
          @change="timeChanged"
        ></mu-time-picker>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>

  import dateFormat from '../../helpers/DatePickerManager'


  export default {
    name: 'date-picker',
    props: {
      iconMode: {
        type: Boolean,
        default: false
      },
      value: {
        type: String,
        default: moment().format('DD-MM-YYYY hh:mm a')
      },
      type: {
        type: String,
        default: "datetime",
        validator: value => {
          switch (value) {
            case 'date':
              return true;
              break;
            case 'datetime':
              return true;
              break;
            default:
              return false;
              break;
          }
        }
      }
    },
    data() {
      return {
        dateFormat: dateFormat,
        date: "",
        time: ""
      }
    },
    mounted() {
      let self = this;
      self.date = moment().format('DD-MM-YYYY');
      self.time = moment().format('hh:mm a');
      self.$nextTick(function () {
        self.emitValue();
      });
    },
    methods: {
      dateChanged(value) {
        let self = this;
        self.date = value;
        self.emitValue();
      },
      timeChanged(value) {
        let self = this;
        self.time = value;
        self.emitValue();
      },
      emitValue() {
        let self = this;
        if (self.isHydrated()) {
          let finalDate;
          if (self.type === "datetime") {
            let dateTime = moment(self.date + ' ' + self.time, 'DD-MM-YYYY hh:mm a');
            finalDate = dateTime.format();
            self.$emit('input', finalDate)
          }
          if (self.type === "date") {
            const date = moment(self.date, 'DD-MM-YYYY');
            const finalDate = date.format('YYYY-MM-DD');
            self.$emit('input', finalDate);
          }
        }
      },
      isHydrated() {
        let self = this;
        if (self.type === "datetime") {
          return (self.time !== "" && self.date !== "");
        }
        else {
          return (self.date !== "");
        }
      }
    }
  }

</script>
<style>
  .blueIcon {
    color: #0179d5 !important;
  }
</style>



// WEBPACK FOOTER //
// DateTimePicker.vue?6bf72df8